import { Button, ButtonGroup, Input } from "@adfenix/alexandria";
import { useContext, useState, KeyboardEvent, useEffect } from "react";

import { ReadLayerContext } from "./ReadLayerQueryContext";

interface PaginationProps {
  columns: Array<string>;
  label?: string;
  placeholder?: string;
  minWidth?: number;
}

export const SearchField = ({
  columns,
  label,
  placeholder,
  minWidth
}: PaginationProps) => {
  const ctx = useContext(ReadLayerContext);

  const [searchTerm, setSearchTerm] = useState(ctx?.query?.searchTerm);

  useEffect(() => {
    if (ctx) {
      setSearchTerm("");
    }
  }, [ctx?.resetCount]);

  useEffect(() => {
    if (ctx && ctx.query.searchTerm !== "") {
      setSearchTerm(ctx.query.searchTerm);
    }
  }, [ctx?.query.searchTerm]);

  if (!ctx) return null;

  const { query, updateQuery } = ctx;

  if (!query || !updateQuery || !columns) return null;

  const search = () => {
    updateQuery({ searchTerm, searchTermColumns: columns });
  };

  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") search();
  };

  return (
    <ButtonGroup alignItems="flex-end">
      <Input
        style={{ minWidth }}
        label={label}
        placeholder={placeholder}
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        onKeyDown={onKeyDown}
      />

      <Button
        logLabel="readlayer-search-button"
        variant="secondary"
        onClick={search}
      >
        Search
      </Button>
    </ButtonGroup>
  );
};
